import { BaseFunction, MESSAGE_ON_TYPE } from "@/types/message";


class MessageDispatchCenter{
  private messageEvent: any = [];

  on(key: MESSAGE_ON_TYPE, callback: BaseFunction){
    if(!this.messageEvent[key]){
      this.messageEvent[key] = [];
    }
    this.messageEvent[key].push(callback);
  }

  emit(key: MESSAGE_ON_TYPE, ...args: any[]){
    if(this.messageEvent[key]&&this.messageEvent[key].length>0){
      this.messageEvent[key].forEach((callback: BaseFunction) => {
        callback(...args);
      });
    }
  }
  off(key: MESSAGE_ON_TYPE, callback: BaseFunction){
    if(this.messageEvent[key]){
      this.messageEvent[key] = this.messageEvent[key].filter((item: BaseFunction) => item !== callback);
    }
  }
}

export default new MessageDispatchCenter();